import { jsx as _jsx } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
import { cn } from '../lib/utils.js';
/**
 * Header element with proper styling for mobile/desktop
 * Adds background and border-bottom for visual separation
 */
export function Header({ element }) {
    const layoutStyles = getLayoutStyles(element);
    const { props } = element;
    // Check if sticky
    const isSticky = props.sticky === true;
    return (_jsx("header", { className: cn('box-border bg-background border-b border-border', isSticky && 'z-10'), style: layoutStyles, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }));
}
//# sourceMappingURL=Header.js.map